import { signInWithCustomToken } from "firebase/auth";
import { FirebaseWebAuthnError } from "./FirebaseWebAuthnError.js";
export const handleVerifyFunctionResponse = (auth, functionResponse) => "customToken" in functionResponse ? signInWithCustomToken(auth, functionResponse.customToken)
    .catch((firebaseError) => {
    throw new FirebaseWebAuthnError({
        code: firebaseError.code.replace("firebaseWebAuthn/", ""),
        message: firebaseError.message,
        method: "signInWithCustomToken",
    });
}) : "code" in functionResponse ? (() => {
    throw new FirebaseWebAuthnError(functionResponse);
})() : (() => {
    throw new FirebaseWebAuthnError({
        code: "invalid",
        message: "Invalid function response.",
        operation: functionResponse.operation,
    });
})();
